export enum DeckPages {
  Flashcards,
  Quiz,
  StudyGuide,
  Edit,
  Share,
  Home
}
